import { projectsProjectDetailHostCapability, projectsProjectDetailHostSlots, } from '@crest/module-projects/contracts/detail-host';
import { platformMyDayHostCapability, platformMyDayHostSlots, } from '@crest/platform-contracts/hosts';
import { defineProjectsProjectDetailLauncher } from '@crest/module-projects/contracts/detail-launcher';
import { mitigationModuleManifest } from '../mitigation.module.js';
import { mitigationSettingRegistrations } from '../settings/mitigation-setting-catalog.js';
export const mitigationWebModuleContribution = {
    moduleId: 'mitigation',
    manifest: mitigationModuleManifest,
    settingRegistrations: mitigationSettingRegistrations,
    settingEditors: [],
    hostContracts: [],
    hostContributions: [{
            id: 'mitigation.web.platform.my-day',
            moduleId: 'mitigation',
            slot: platformMyDayHostSlots.primary,
            contractVersion: platformMyDayHostCapability,
            requiredPermission: 'mitigation.daily-monitoring.read',
            settingCondition: {
                key: 'mitigation.field-completion.configuration',
                property: 'panelEnabled',
                equals: true,
            },
            priority: 18,
            errorBehavior: 'inline',
            emptyBehavior: 'collapse',
            load: () => import('./mitigation-my-day.panel.js'),
        }, {
            id: 'mitigation.web.projects.moisture-evidence',
            moduleId: 'mitigation',
            slot: projectsProjectDetailHostSlots.tabs,
            contractVersion: projectsProjectDetailHostCapability,
            requiredPermission: 'mitigation.moisture-evidence.read',
            settingCondition: {
                key: 'mitigation.moisture-evidence.configuration',
                property: 'panelEnabled',
                equals: true,
            },
            priority: 30,
            errorBehavior: 'inline',
            emptyBehavior: 'inline',
            launcher: defineProjectsProjectDetailLauncher({
                fallbackLabel: 'Mitigation',
                fallbackDescription: 'Open moisture evidence, drying, and field completion tools.',
                defaultSize: 'large',
                supportedSizes: ['standard', 'wide', 'large'],
            }),
            load: () => import('./mitigation-moisture-evidence-panel.js'),
        }, {
            id: 'mitigation.web.projects.drying-workspace',
            moduleId: 'mitigation',
            slot: projectsProjectDetailHostSlots.tabs,
            contractVersion: projectsProjectDetailHostCapability,
            requiredPermission: 'mitigation.drying.read',
            settingCondition: {
                key: 'mitigation.drying.configuration',
                property: 'panelEnabled',
                equals: true,
            },
            priority: 31,
            errorBehavior: 'inline',
            emptyBehavior: 'inline',
            load: () => import('./mitigation-drying-workspace.panel.js'),
        }, {
            id: 'mitigation.web.projects.field-completion',
            moduleId: 'mitigation',
            slot: projectsProjectDetailHostSlots.tabs,
            contractVersion: projectsProjectDetailHostCapability,
            requiredPermission: 'mitigation.daily-monitoring.read',
            settingCondition: {
                key: 'mitigation.field-completion.configuration',
                property: 'panelEnabled',
                equals: true,
            },
            priority: 32,
            errorBehavior: 'inline',
            emptyBehavior: 'inline',
            load: () => import('./mitigation-field-completion.panel.js'),
        }, {
            id: 'mitigation.web.projects.contents',
            moduleId: 'mitigation',
            slot: projectsProjectDetailHostSlots.tabs,
            contractVersion: projectsProjectDetailHostCapability,
            requiredPermission: 'mitigation.contents.read',
            settingCondition: {
                key: 'mitigation.contents.configuration',
                property: 'panelEnabled',
                equals: true,
            },
            priority: 33,
            errorBehavior: 'inline',
            emptyBehavior: 'inline',
            load: () => import('./mitigation-contents.panel.js'),
        }],
    routes: [{
            id: 'mitigation.web.psychrometrics',
            moduleId: 'mitigation',
            path: '/mitigation/psychrometrics',
            requiredPermission: 'mitigation.psychrometrics.use',
            settingCondition: {
                key: 'mitigation.psychrometrics.configuration',
                property: 'pageEnabled',
                equals: true,
            },
            navigation: {
                id: 'mitigation.navigation.psychrometrics',
                fallbackLabel: 'Psychrometrics',
                labelConfigurationKey: 'mitigation.copy.psychrometrics',
                labelValueProperty: 'navigationLabel',
                priority: 63,
            },
            load: () => import('./mitigation-psychrometrics.page.js'),
        }],
};
export default mitigationWebModuleContribution;
//# sourceMappingURL=mitigation-web.module-contribution.js.map